import EmbedVideo from '@/pages/videos/embedVideo.vue';

export default [{
    path: '/video/:id/:permalink',
    name: 'EmbedVideo',
    component: EmbedVideo,
    meta: {
        pageTitle: 'frontend_groovevideo_routes_video'
    }
}, ];